module.exports = __webpack_public_path__ + "b5a61b229c9c92a6ac21f5b0e3c6e9f1.svg";